<template>
  <div>
    <Top />
    <header class="box">

      <!-- logo -->
      <!-- <div>
        <div>
          <a href="/">
            <img class="logoImg" src="../imgs/logo.svg" />
          </a>
        </div>
      </div> -->

      <div class="rideoList">
        <el-radio-group style="height:100%" v-model="tab" @change="changeTab">
          <el-radio-button style="height:100%" label="img">图片管理</el-radio-button>
          <el-radio-button style="height:100%" label="video">视频管理</el-radio-button>
          <el-radio-button style="height:100%" label="sell">销售数据</el-radio-button>
        </el-radio-group>
      </div>
      <!-- <div class="header-upload-btn" v-if="tabIndex==0"> -->
      <!-- 右边 -->
      <div class="header-right">
        <el-button size="small" style="background-color:#DB3A3B;color:#fff" @click="plugin">插件上传</el-button>
        <el-button size="small" style="background-color:#DB3A3B;color:#fff" @click="dialogVisible = true"
          icon="el-icon-upload">供稿
        </el-button>
      </div>
    </header>
    <!-- 选择图片或者视频对话框 -->
    <el-dialog title="" :visible.sync="dialogVisible" width="40%">
      <!-- 上传图片 -->
      <div class="imgUpload">
        <div class="img-top" style="margin-top:0px">上传图片</div>
        <div class="img-foot">
          <!-- <div class="box1" @click="click1">
            <p>图片有奖征稿</p>
            <h5>参与云上世界征稿活动，获取活动奖励， 作品出售后获得分成</h5>
          </div>
          <div class="box1" @click="click2">
            <p>图片任务供稿</p>
            <h5>与云上世界签约拍摄指定区域图片 作品出售后获得分成</h5>
          </div> -->
          <div class="box1" @click="click3">
            <p>图片供稿</p>
            <h5>将图片作品上传至精品图库， 作品出售后获得分成</h5>
          </div>
        </div>
      </div>
      <div class="imgUpload" style="margin-top:15px">
        <div class="img-top" style="margin-top:0px">上传视频</div>
        <div class="img-foot">
          <!-- <div class="box1" @click="click4">
            <p>视频有奖征稿</p>
            <h5>参与云上世界征稿活动，获取活动奖励， 作品出售后获得分成</h5>
          </div>
          <div class="box1" @click="click5">
            <p>视频任务供稿</p>
            <h5>与云上世界签约拍摄指定区域视频 作品出售后获得分成</h5>
          </div> -->
          <div class="box1" @click="click6">
            <p>视频供稿</p>
            <h5>将视频作品上传至精品图库， 作品出售后获得分成</h5>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 上传图片组件 -->
    <ImgUpload ref="ImgUploadRef" v-if="isBoxShow" :isBoxShow.sync="isBoxShow" :isLessShow.sync="isLessShow"
      :feedType.sync="feedType" @isLessShowClick="isLessShowClick(arguments)" @isBigShowClick="isBigShowClick(arguments)"
      v-on="$listeners">
    </ImgUpload>
    <VideoUpload ref="videoUploadRef" v-if="isBoxShow1" :isBoxShow1.sync="isBoxShow1" :isLessShow1.sync="isLessShow1"
      :feedType2.sync='feedType2' @isLessShowClick1="isLessShowClick1(arguments)"
      @isBigShowClick1="isBigShowClick1(arguments)" v-on="$listeners" />

    <!-- 上传插件对话框 -->
    <transition name="el-zoom-in-bottom">
      <div v-show="uploadPlugin" class="transition-box plugin">
        <div class="plugintop">
          <div class="downLoad">
            <span>插件上传</span>
            <el-button size="mini" @click="downLoadPlugin" style="border-color: rgb(254, 232, 213);
                  background-color: rgb(255, 247, 241);color: #db3a3b;">下载插件</el-button>
          </div>
          <i class="el-icon-close" @click="closePlugin"></i>
        </div>
        <div class="tips">
          <p>请注意！</p>
          <p> 1.请确认您拥有上传视频素材的著作权或版权，如有侵权行为，您将承担相应的法律责任。
          </p>
          <p> 2.视频分辨率≥200w像素；单个文件≤2GB,格式限AVI、nAVI、ASF、WMV、MOV、MP4格式。
          </p>
          <p> 3.视频素材时长≤300s.
          </p>
        </div>
        <div class="pluginMiddle">
          <el-input clearable placeholder="请输入路径" v-model.trim="uploadPluginVal" class="input-with-select">
            <el-button slot="append" type="primary" @click="upladpluginOK">提交</el-button>
          </el-input>

          <div class="list" v-if="fileList && fileList.length">
            <div class="item" v-for="(item, index) in fileList" :key="index">
              <div class="img">
                <img v-if="imgType.includes(item.format)" src="@/imgs/imgthumbnail.svg" alt="">
                <img v-else-if="videoType.includes(item.format)" src="@/imgs/videothumbnail.svg" alt="">
                <img v-else src="@/imgs/none.svg" alt="">
              </div>
              <span class="filename">{{ item.name }}</span>
              <span class="size">{{ item.size }}MB</span>
              <span class="format">{{ item.format }}</span>
              <span class="pro"> <el-progress v-if="progressList"
                  :percentage="progressList.progress[index]"></el-progress></span>
              <span class="fail" v-if="item.state == 'ERROR'" :title="item.msg">{{ item.msg }}</span>
              <span class="success" v-else-if="progressList.progress[index] == 100">上传成功！</span>
              <span class="success" v-else>上传中...</span>
            </div>
          </div>
        </div>
        <div class="pluginbottom">
          <div class="left">{{ successNum }}个文件上传成功 &nbsp; &nbsp; {{ errorNum }}个文件上传失败</div>
          <div class="right">
            <el-button :disabled="delItem" @click="delFailItem">清空上传失败项</el-button>
            <!-- <el-button :disabled="pushEdit" type="primary" @click="gopushEdit">去编辑</el-button> -->
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import Top from '@/components/top.vue'
import ImgUpload from "@/views/contributor/components/imgUpload.vue"
import VideoUpload from "@/views/contributor/components/videoUpload.vue"
export default {
  props: ['editBtnShow'],
  name: 'vheader',
  data() {
    return {
      imgType: ['JPEG', 'jpeg', 'png', 'PNG', 'jpg', 'JPG'],
      videoType: ['mov', 'MOV', 'MP4', 'mp4'],
      feedType: 0,  //上传照片类型,1 任务征稿 2 自然供稿 3 有奖征稿
      feedType2: 0,  //上传视频类型,1 任务征稿 2 自然供稿 3 有奖征稿
      tab: "img",
      isBoxShow: false, //控制上传组件显示隐藏
      isLessShow: false, //最小化,最大化控制
      dialogVisible: false, //选择图片视频对话框
      isBoxShow1: false, //控制视频上传组件显示隐藏
      isLessShow1: false, //视频组件最小化,最大化控制,
      uploadPlugin: false, //上传插件
      uploadPluginVal: '',//上传插件输入框绑定值
      userInfo: {},//
      fileList: [],
      keyList: [],//key数组
      progressList: '',//进度条数组
      timer: null,//定时器
      successNum: 0,//成功数量//
      errorNum: 0,//失败数量//
      delItem: true,//清空失败项按钮
      pushEdit: true,//去编辑按钮
    }
  },
  methods: {
    //下载插件
    downLoadPlugin() {
      window.location.href = "https://www.yunshangzg.com/upload/exe/yssj-upload.zip"
    },
    //点击上传插件
    plugin() {
      this.uploadPlugin = true
      this.$emit('clcikeditBtn', true)
    },
    closePlugin() {
      this.uploadPlugin = false
      this.$emit('clcikeditBtn', false)
    },
    //点击上传插件提交
    async upladpluginOK() {
      // this.uploadPluginVal = this.uploadPluginVal.replaceAll("\",  )
      if (!this.uploadPluginVal) {
        return this.$message.error('请填写路径')
      }
      let str = this.uploadPluginVal.replace(/\\/g, "/"); //将路径里的\替换成/
      const res = await this.$axios.post(`http://localhost:8867/upload/file?folderPath=${str}&userid=${this.userInfo.userId}`)
      if (res.success) {
        this.fileList = res.data
        this.timer = setInterval(() => {
          this.progress()
        }, 1000)
      } else {
        this.$message.error(res.data)
      }
    },
    // 调用进度条
    async progress() {
      this.delItem = true
      this.pushEdit = true
      this.keyList = []
      // this.progressList = []
      this.fileList.forEach(item => {
        this.keyList.push(item.key)
      })
      const res = await this.$axios.post('http://localhost:8867/upload/progress', this.keyList)
      this.progressList = res.data
      //如果成功了清除进度条方法定时器
      if (this.progressList.state == 'SUCCESS') {
        clearInterval(this.timer);
        //成功数量
        this.successNum = this.progressList.progress.filter(item => item == 100).length
        this.errorNum = this.progressList.progress.length - this.successNum
        this.delItem = false
        this.pushEdit = false
      }
    },
    //删除失败项
    delFailItem() {
      //把页面列表显示成功的（以防进度条错位）
      this.progressList.progress = this.progressList.progress.filter(item => item == 100)
      this.fileList = this.fileList.filter(item => item.state !== 'ERROR')
    },
    //去编辑
    // gopushEdit() {
    //   this.tab1 = 'img'
    //   // this.$nextTick(() => {
    //   //   this.$refs.ImgAdminRef.activeName = 'two'
    //   //   this.iBtnShow = false
    //   //   this.$refs.headerRef.isBoxShow = false
    //   // })

    // },

    // 子传父--点击最小化
    isLessShowClick(msg) {
      this.isBoxShow = msg[0]
      this.isLessShow = msg[1]
      // console.log(msg[0], msg[1]);
    },
    // 子传父--点击最大化
    isBigShowClick(msg) {
      this.isBoxShow = msg[1]
      this.isLessShow = msg[0]
    },
    // 子传父--点击最小化
    isLessShowClick1(msg) {
      this.isBoxShow1 = msg[0]
      this.isLessShow1 = msg[1]
      // console.log(msg[0], msg[1]);
    },
    // 子传父--点击最大化
    isBigShowClick1(msg) {
      this.isBoxShow1 = msg[1]
      this.isLessShow1 = msg[0]
    },
    changeTab() {
      this.$emit('updateTab', this.tab)
    },
    download() {
      window.location.href = 'https://img.yunshangzg.com/work/TUYING.rar'
    },
    // 有奖图片
    click1() {
      this.isBoxShow = true
      this.isBoxShow1 = false
      this.dialogVisible = false
      this.feedType = 3
      this.$emit('imgBtnShow', this.isBoxShow)
    },
    // 任务图片
    click2() {
      this.isBoxShow = true
      this.isBoxShow1 = false
      this.dialogVisible = false
      this.feedType = 1
      this.$emit('imgBtnShow', this.isBoxShow)
    },
    // 自然图片
    click3() {
      this.isBoxShow = true
      this.isBoxShow1 = false
      this.dialogVisible = false
      this.feedType = 2
      this.$emit('imgBtnShow', this.isBoxShow)
    },
    // 有奖视频
    click4() {
      this.isBoxShow = false
      this.isBoxShow1 = true
      this.dialogVisible = false
      this.feedType2 = 3
      this.$emit('videoBtnShow', this.isBoxShow1)
    },
    // 任务视频
    click5() {
      this.isBoxShow = false
      this.isBoxShow1 = true
      this.dialogVisible = false
      this.feedType2 = 1
      this.$emit('videoBtnShow', this.isBoxShow1)
    },
    // 自然视频
    click6() {
      this.isBoxShow = false
      this.isBoxShow1 = true
      this.dialogVisible = false
      this.feedType2 = 2
      this.$emit('videoBtnShow', this.isBoxShow1)
    }
  },
  created() {
    // console.log(this.editBtnShow);
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    // this.$bus.$on('data', (value) => {
    //   this.tab = value;
    //   console.log(this.tab);
    // })
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  components: { ImgUpload, VideoUpload, Top }
}
</script>
<style scoped lang="scss">
// 上传插件
.plugin {
  position: fixed;
  bottom: 40px;
  right: 10px;
  background-color: #fff;
  width: 700px;
  z-index: 99;
  border: 1px solid #eee;

  .plugintop {
    font-size: 14px;
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-bottom: 1px solid #EEE;
  }

  .tips {
    padding: 20px;
    font-size: 14px;

    p {
      color: #808080;

      &:nth-child(1) {
        color: #E73D4A;
      }
    }
  }

  .pluginMiddle {
    overflow: auto;
    border-top: 1px solid #eee;
    padding: 20px;
    height: 550px;

    /deep/ .el-input-group__append {
      background-color: #E73D4A !important;
      color: #fff !important;
    }

    .list {
      margin-top: 30px;

      .item {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;



        span {
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .filename {
          width: 100px;
        }

        .success {
          width: 100px;
          color: #09BA07;
        }

        .fail {
          width: 100px;
          color: #E73D4A;
        }

        img {
          width: 30px;
          height: 30px;
        }


        .pro {
          width: 150px;
        }

        .el-progress {
          width: 150px;
        }
      }
    }

  }

  .pluginbottom {
    font-size: 14px;
    border-top: 1px solid #eee;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;

    .left {
      color: #999999;
    }
  }
}

.box {
  width: 100vw;
  height: 60px;
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;


}



.header-right {
  el-button {
    width: 150px
  }
}


.imgUpload {
  .img-top {
    width: 100%;
    height: 60px;
    line-height: 60px;
    font-size: 24px;
    text-align: center;
    background-color: #999999;
    color: #ffffff;
    margin-top: 25px;
  }

  .img-foot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 210px;
    line-height: 30px;
    text-align: center;
    background-color: #ffffff;
    border: 1px solid #ccc;
    color: #999999;
    font-size: 24px;

    .box1 {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      height: 100%;
      transition: all 0.2s;

      &:hover {
        background-color: #dc383b;
        color: #fff;
      }

      p {
        margin-bottom: 30px;
      }

      h5 {
        font-size: 12px;
        font-weight: normal;
      }
    }
  }
}

.logoImg {
  width: 160px;
  height: 28px;
}

@import "../theme/common.css";

/deep/ .el-radio-button__inner {
  line-height: 31px;
  height: 100%;
  width: 200px;
  text-align: center;
  font-size: 17px;
  border: none;
}


/deep/ .el-radio-button:first-child .el-radio-button__inner {
  border: none;
}

.rideoList {
  padding-left: 580px;
}
</style>



// WEBPACK FOOTER //
// src/components/vheader.vue